import { TextField, TextFieldProps } from "@mui/material";

// Campo de texto das telas Branded: mesma anatomia do campo Default (outlined + label
// flutuante que sobe para a borda no foco), mas com as CORES DA MARCA (tokens do tema, sem
// hex). NÃO reusa StyledTextField (hex da Atem fixo + Fragment que causava o bug de
// espaçamento). Um único elemento raiz (TextField), para o gap da coluna reger o espaçamento.
//
// - variant outlined, size small, fullWidth → altura ~40px.
// - input 1.6rem (abaixo disso o Safari iOS dá zoom no foco). O label NÃO fixa fontSize:
//   herda a fonte do input (16px parado / 12px encolhido), para o notch que o MUI calcula
//   (0.75 × fonte do input) casar com a largura do texto do label.
// - foco/label focado = primary.main; erro = error.main; fundo = background.paper.
// - mensagem de erro via helperText do MUI.
// - autofill do Chrome sem fundo azul: box-shadow inset em background.paper (token, sem hex).
export type BrandedTextFieldProps = Omit<TextFieldProps, "variant" | "size"> & {
  // erro/ajuda já resolvidos pelo chamador (error = touched && !!error).
  error?: boolean;
  helperText?: React.ReactNode;
};

export const BrandedTextField: React.FC<BrandedTextFieldProps> = ({ sx, ...props }) => (
  <TextField
    variant="outlined"
    size="small"
    fullWidth
    {...props}
    // sx como array: o chamador pode passar objeto, função ou array — todos são
    // preservados (MUI achata arrays de sx), não só objeto.
    sx={[
      {
        "& .MuiInputBase-input": { fontSize: "1.6rem" },
        "& .MuiInputLabel-root.Mui-focused": { color: "primary.main" },
        "& .MuiOutlinedInput-root": {
          bgcolor: "background.paper",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "primary.main" },
        },
        // Chrome autofill: mantém o fundo do tema (sem o amarelo/azul do browser).
        "& input:-webkit-autofill": {
          WebkitBoxShadow: (theme) => `0 0 0 100px ${theme.palette.background.paper} inset`,
          WebkitTextFillColor: (theme) => theme.palette.text.primary,
          caretColor: (theme) => theme.palette.text.primary,
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);
